
import * as React from 'react';

const Dropdown = (props) => {
    const { ddlList, value, label, selectedValue, canSelectMultiple, disabledValues, hideEmptyValueOption } = props;

    const onChangeDdl = async (evt, data) => {
        if (canSelectMultiple) {
            if (disabledValues && disabledValues.includes(data)) return;

            const selectedValues = Array.isArray(selectedValue)
                ? [...selectedValue]
                : selectedValue ? [selectedValue] : [];

            if (selectedValues.includes(data)) {
                selectedValues.splice(selectedValues.indexOf(data), 1);
            } else {
                selectedValues.push(data);
            }

            props.onDdlCallback(selectedValues);
        } else {
            $(`#${props.id}`).removeClass('open');
            props.onDdlCallback(data);
        }
    }

    const selectedText = !canSelectMultiple && ((ddlList && selectedValue) &&
        (value ? (ddlList.find(f => f[`${value}`] === selectedValue)[`${label}`])
            : (ddlList.find(f => f === selectedValue)))
    )

    const textToDisplay = () => {
        if (canSelectMultiple) {
            if (Array.isArray(selectedValue) && selectedValue.length) {
                const selectedOptionLabels = [];
                ddlList.map((item) => {
                    if (selectedValue.includes(item[value])) {
                        selectedOptionLabels.push(item[label]);
                    }
                });
                return selectedOptionLabels.join(', ');
            }
        } else if (selectedValue) {
            return selectedText;
        }
        return props.defaultText;
    }

    const isItemActive = (itemValue) => {
        if (canSelectMultiple) {
            return Array.isArray(selectedValue) && selectedValue.includes(itemValue);
        }
        return selectedValue === itemValue;
    }

    return (
        <>
            <div className="dropdown selectbox order-dropdown show" id={props.id}>
                <a className="bs5 form-control form-control-sm text-black dropdown-control w180 my-cart-address-select dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span> {textToDisplay()}</span>
                </a>
                <ul className="dropdown-menu minw180" aria-labelledby="dropdownMenuLink">
                    {!canSelectMultiple && !hideEmptyValueOption && (
                        <li value="">
                            <a className="dropdown-item text-black" onClick={async (e) => {
                                onChangeDdl(e, "");
                            }}><p>{props.defaultText}</p></a>
                        </li>
                    )}
                    {(ddlList !== undefined && ddlList.length > 0) &&
                        ddlList.map((v) => {
                            const itemValue = value ? v[`${value}`] : v;
                            const isDisabled = disabledValues && disabledValues.includes(itemValue);
                            return (
                                <li key={itemValue}
                                    value={itemValue}
                                    className={`${isItemActive(itemValue) ? 'active' : ''} ${isDisabled ? 'disabled' : ''}`}
                                    onClick={async (e) => {
                                        if (canSelectMultiple) e.stopPropagation();
                                        onChangeDdl(e, itemValue);
                                    }}
                                >
                                    <a className={`dropdown-item text-black${isDisabled ? ' link-disabled' : ''}`}>
                                        {canSelectMultiple && (
                                            <input
                                                type="checkbox"
                                                checked={Array.isArray(selectedValue) && selectedValue.includes(v[value])}
                                                className="form-check-input parent-check-input ps-0 ms-0 dropdown-checkbox"
                                                readOnly={true}
                                                disabled={isDisabled}
                                            />
                                        )}
                                        <p>{label ? v[`${label}`] : v}</p>
                                    </a>
                                </li>
                            );
                        })
                    }
                </ul>

            </div>
        </>
    );

};

export default React.memo(Dropdown);

